export const initialPatientFormData = {
    patient_type: "",
    unit_id:"",
    physician_id: "",
    patient_name:"",
    reg_date:"",
    father_husband_name:"",
    taluka_id:"",
    location:"",
    distance:"",
    age:"",
    dob:"",
    gender:"",
    patient_cnic:"",
    address:"",
    mobile:"",
    any_govt_id:"",
    prescription_pad_no:"",
    system_number:"mhu-26-00001",
    diagnosis:"",
    other_identifiers:"",
    temperature:"",
    height:"",
    weight:"",
    pulse:"",
    bp:"",
    blood_group:"",
    rr:"",
    active_medications:"",
    inactive_medications:"",
    significant_medications:"",
    alert_intolerance:"",
    visit_history:"",
    chief_complaints:"",
    care_plan_notes:"",
    medical_history:"",
    referral_to_specialist:"",
    is_referral:"",
    ot_date:"",
    referred_by:"",
    admission_date_time:"",
    ward_type:"",
    bed:"",
    previous_admission_date:"",
    previous_discharge_date:"",
    note_special_circumstances:"",
    status:true,
    attachments: [],
}


export const editData = (details = {}) => {
    return {
    ...initialPatientFormData,
    ...details,
    attachments: [],
    }
};
